import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-no-sites',
    templateUrl: './no-sites.component.html',
    styleUrls: ['./no-sites.component.scss'],
    standalone: false
})
export class NoSitesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
